module.exports = __webpack_public_path__ + "static/base-a35bf3f2e18a7cfc6ff042ece0453947.png";